"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _FormDropdown = _interopRequireDefault(require("./FormDropdown"));

var _FormDropdownOption = _interopRequireDefault(require("./FormDropdownOption"));

var _excluded = ["sortOptions", "selected", "handleChange"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Container = _styledComponents.default.div.withConfig({
  displayName: "SortDropdown__Container",
  componentId: "sc-1jr9hwk-0"
})(["display:flex;align-items:baseline;"]);

var Label = _styledComponents.default.div.withConfig({
  displayName: "SortDropdown__Label",
  componentId: "sc-1jr9hwk-1"
})(["text-transform:uppercase;font-weight:600;font-size:1.2rem;letter-spacing:0.3px;color:#77899e;padding-right:1rem;"]);

var SortDropdown = /*#__PURE__*/function (_React$Component) {
  _inherits(SortDropdown, _React$Component);

  var _super = _createSuper(SortDropdown);

  function SortDropdown() {
    _classCallCheck(this, SortDropdown);

    return _super.apply(this, arguments);
  }

  _createClass(SortDropdown, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          sortOptions = _this$props.sortOptions,
          selected = _this$props.selected,
          handleChange = _this$props.handleChange,
          props = _objectWithoutProperties(_this$props, _excluded);

      return /*#__PURE__*/_react.default.createElement(Container, _extends({
        className: "sort-dropdown"
      }, props), /*#__PURE__*/_react.default.createElement(Label, null, "Sort By"), /*#__PURE__*/_react.default.createElement(_FormDropdown.default, {
        onChange: function onChange(event) {
          return handleChange(event.target.value);
        }
      }, sortOptions.map(function (_ref) {
        var name = _ref.name;
        return /*#__PURE__*/_react.default.createElement(_FormDropdownOption.default, {
          key: name,
          value: name,
          optionLabel: name,
          selected: name === selected ? 'selected' : null
        });
      })));
    }
  }]);

  return SortDropdown;
}(_react.default.Component);

_defineProperty(SortDropdown, "propTypes", {
  handleChange: _propTypes.default.func.isRequired,
  sortOptions: _propTypes.default.arrayOf(_propTypes.default.shape({
    name: _propTypes.default.string,
    key: _propTypes.default.string,
    sortBy: _propTypes.default.string,
    sortDir: _propTypes.default.string
  }))
});

_defineProperty(SortDropdown, "defaultProps", {
  sortOptions: []
});

var _default = SortDropdown;
exports.default = _default;